import { showLinkedImageDialog, RESULT_SUCCESS } from "../UI/linkedImage";

const promptLinkedImage = async (nodeId, nodeLookup) => {
    const contextNode = nodeLookup.getNodeById(nodeId);

    if (!contextNode) {
        throw new Error("Could not find node for linked image, id: " + nodeId);
    }

    const currentValue = contextNode.value();

    const { result, data } = await showLinkedImageDialog(currentValue);

    if (result === RESULT_SUCCESS) {
        await contextNode.setValueAsync(data);

        return true;
    }

    return false;
};

export default promptLinkedImage;